import React from 'react'

import { Box, Typography } from "@mui/material"
import { IconSeeker } from '@ui-seeker/core'

export default function embargoStatusColumn() {

	const statusColors = {
		met: 'success.main',
		needsAction: 'error.main',
		notMet: 'warning.main',
	}

	const statusIcons = {
		met: 'check',
		needsAction: 'xmark',
		notMet: 'hourglass',
	}

	const textMapper = {
		met: 'Met',
		notMet: 'Not Met',
		needsAction: 'Needs Action',
	}

	return [{
			name: 'embargoStatus',
			label: 'Embargo Status',
			options: {
				display: 'excluded',
				customBodyRowRender: value => textMapper[value]
			}
		}, {
		name: 'embargoStatus',
		label: 'Embargo Status',
		options: {
			filter: false,
			customBodyRowRenderLite: value => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mr: '8px' }}>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							p: 1,
							gap: 1,
							backgroundColor: statusColors[value],
							borderRadius: "12px",
							minWidth: "100px",
							maxWidth: "200px",
						}}
					>
						<IconSeeker iconWeight='solid' icon={statusIcons[value]} sx={{ color: "white", fontSize: 12 }} />
						<Typography sx={{ fontWeight: "bold", color: "white", fontSize: '12px' }}>
							{textMapper[value]}
						</Typography>
					</Box>
				</Box>
			)
		}
	}]
}
